import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import MasterList from "../../../common/MasterList";
import ModalBody from "../../../common/ModalBody";
import ModalHeader from "../../../common/ModalHeader";
import { formatDateTime } from "../../../../common/Validations";
import Constants from "../../../../common/Constants";

const AckRecords = ({ rowsData = [], show, onHide, jobcard }) => {
  const { t } = useTranslation();

  const columnsData = [
    {
      name: "Jobcard",
      selector: (row) => row.jobcard,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="mt-3 bg-table-status bg-table-new-status">
            {row.jobcard}
          </p>
        </div>
      ),
    },
    {
      name: "Department",
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.toDeptCode}</p>
          <p className="m-0 p-0">{row.toDeptName}</p>
        </div>
      ),
    },
    {
      name: t("msg_reports.msg_production_status.size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.sizeCode}</p>
          <p className="m-0 p-0">{row.sizeName}</p>
        </div>
      ),
    },
    {
      name: "Acknowledged By",
      selector: (row) => row.loginUserName,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {row.loginUserName}
          </p>
        </div>
      ),
    },
    {
      name: "Acknowledged Date",
      selector: (row) => row.operatorcreatedDate,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(
              row.operatorcreatedDate ? row.operatorcreatedDate : row.createdDate
            )}
          </p>
        </div>
      ),
    },
  ];

  return (
    <Modal
      show={show}
      onHide={onHide}
      animation={false}
      dialogClassName="modal-70w"
      backdrop="static"
    >
      <ModalHeader title="Acknowledged Records" />
      <ModalBody>
        <MasterList
          columnsData={columnsData}
          rowsData={rowsData}
          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
          pagination
          selectableRows={false}
          handleClose
          cardHeader={false}
        />
      </ModalBody>
    </Modal>
  );
};

export default AckRecords;